export default __webpack_public_path__ + "assets/images/aistudio/views/6733fe24c711cff0aa04ac768d032af7.png";